import { useParams } from "react-router-dom";
import Frame from "../Frames/Basic";
import PiSignatureForm from "./PiSignatureForm";

export default function PiSignature(){

    const {id} = useParams()

    return <Frame>

        <PiSignatureForm id={id} />

    </Frame>


}